module.exports = __webpack_public_path__ + "static/media/img_dance05.97e3f99a.png";